var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStLucia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C31.0455 40 39.9998 31.0457 39.9998 20C39.9998 8.9543 31.0455 0 19.9998 0C8.95415 0 -0.000152588 8.9543 -0.000152588 20C-0.000152588 31.0457 8.95415 40 19.9998 40Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6086 26.9564H27.3912L19.9999 9.56519L12.6086 26.9564Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1774 25.2174L20 14.2479L24.8226 25.2174H15.1774Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6086 26.9565H27.3912L19.9999 20L12.6086 26.9565Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStLucia);
export default __webpack_public_path__ + "static/media/st_lucia.1c2528350a1fa9625faac12a51775b36.svg";
export { ForwardRef as ReactComponent };